var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-card',{attrs:{"title":" Testeste A/B 🙌"}},[_c('b-card-text',[_vm._v("Testeste A/B")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }